export default "__VITE_ASSET__CnufoUZI__"